/* eslint-disable no-undef */
import axios from 'axios';
import getSearchFilterUrl from './searchFilterUrl';
import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';
import { VITE_SEARCH_FILTER_URL } from 'Constants/appEnvConstants'

const baseUrl = getSearchFilterUrl();

function post(postUrl, postData) {
  return axios({
    method: 'post',
    url: postUrl,
    data: postData,
  })
    .then(onSuccess)
    .catch(onError);
}

export function getFiltersBasedOnSearchTypeId(searchTypeId, isCustomQueue) {
  configureHttpHeaders(axios);
  let url;
  if (!!isCustomQueue) {
    url = `api/v1/filters/${searchTypeId}?isCustomQueue=${isCustomQueue}`;
  } else {
    url = `api/v1/filters/${searchTypeId}`;
  }

  return get(url);
}

export function getDataAccordingToSearchFilters(filters, filterTypeId, pageNumber, size, sort, acquirerAccessList) {
  const Url = 'api/v1/filterParams/filter/search';
  configureHttpHeaders(axios);
  const sortObj = sort.map((obj) => {
    return {
      fieldId: obj.key,
      orderByProperty: obj.order ? 'ASC' : 'DESC',
    };
  });
  const searchInputDetails = {
    pageNumber,
    searchFilterInputElements: filters,
    filterTypeId,
    size,
    sortingElement: sortObj,
    acquirerAccessList: acquirerAccessList,
  };
  return post(VITE_SEARCH_FILTER_URL + Url, searchInputDetails);
}

export function getRelatedCaseSearchData(args) {
  const Url = 'api/v1/filterParams/filter/related/casesearch';
  configureHttpHeaders(axios);
  const sortObj = args.sortArr.map((obj) => {
    return {
      fieldId: obj.key,
      orderByProperty: obj.order ? 'ASC' : 'DESC',
    };
  });

  const relatedCaseSearchInput = {
    acquirerCode: args.acquirerCode,
    globalToken: args.globalToken,
    merchantNumber: args.merchantNumber,
    pageNumber: args.pageNumber,
    size: args.size,
    sortingElement: sortObj,
  };
  return post(VITE_SEARCH_FILTER_URL + Url, relatedCaseSearchInput);
}

export function postActiveFilterValues(searchTypeId, activeFilters, filterName, customQueueId) {
  let url = `${VITE_SEARCH_FILTER_URL}api/v1/filters/${searchTypeId}`;
  if (customQueueId) {
    url = url + `?customQueueId=${customQueueId}`;
  }
  const data = {
    filterElements: activeFilters,
    filterName,
    userId: 'SYSTEM',
  };
  configureHttpHeaders(axios);
  return post(url, data);
}

export function getSavedFiltersBasedOnSearchTypeId(searchTypeId, customQueueId) {
  configureHttpHeaders(axios);
  let url = `api/v1/filters/category/${searchTypeId}`;
  if (customQueueId) {
    url = url + `?customQueueId=${customQueueId}`;
  }
  return get(url);
}

export function deleteSavedFilter(filterId) {
  configureHttpHeaders(axios);
  return deleteFilter(`api/v1/filters/${filterId}`);
}

export function getSearchTypeIdBasedOnSearchTypeName(searchTypeName) {
  configureHttpHeaders(axios);
  return get(`api/v1/filters/category/${searchTypeName}/id`);
}

export function getDynamicFitlersAccToQueueMgmtPage(queueId) {
  configureHttpHeaders(axios);
  return get(`api/v1/filters/dynamic/${queueId}`);
}

export function getDynamicFitlersAccCustomQueue(queueId, customQueueId) {
  let url = `api/v1/filters/dynamic/${queueId}`;
  if (customQueueId) {
    url = url + `?customQueueId=${customQueueId}`;
  }
  configureHttpHeaders(axios);
  return get(url);
}

export function postActiveDynamicFilters(filterTypeId, activeFilters, customQueueId) {
  let url = `${VITE_SEARCH_FILTER_URL}api/v1/filters/saveFilter`;
  if (customQueueId) {
    url = url + `?customQueueId=${customQueueId}`;
  }
  const data = {
    filterId: filterTypeId,
    savedFilterElements: activeFilters,
  };
  configureHttpHeaders(axios);
  return post(url, data);
}

export function getSortOrderToCustomQueuePage() {
  configureHttpHeaders(axios);
  return get(`api/v1/filters/sort/order`);
}

export function getSortFiltersParamToCustomQueuePage() {
  configureHttpHeaders(axios);
  return get(`api/v1/filters/sort/filterParam`);
}

function get(url) {
  return axios.get(`${baseUrl}${url}`).then(onSuccess).catch(onError);
}

function deleteFilter(url) {
  return axios.delete(`${baseUrl}${url}`).then(onSuccess).catch(onError);
}

export default {
  getFiltersBasedOnSearchTypeId,
  getDataAccordingToSearchFilters,
  getSavedFiltersBasedOnSearchTypeId,
  postActiveFilterValues,
  deleteSavedFilter,
  getSearchTypeIdBasedOnSearchTypeName,
  getDynamicFitlersAccToQueueMgmtPage,
  postActiveDynamicFilters,
  getDynamicFitlersAccCustomQueue,
};
